import { useState } from 'react'
import type { StepInputProps } from './StepInput'

// Slider-grænser pr. audience. Unge har et tæt segment (17-30+) hvor hvert år
// flytter prisen meget; aeldre dækker hele bilist-spektret op til 80+ så
// pensionist-segmentet ikke skal mappes til en sentinel allerede ved 30.
// Min=17 på unge: 17-årige kan tegne bilforsikring i Danmark (køreuddannelse
// kan starte fra 16 år 9 mdr, og ledsagerkørsel kræver forsikring) — så
// vi må ikke afvise dem i flowet.
const AGE_BOUNDS = {
  unge:   { min: 17, max: 30, default: 25 },
  aeldre: { min: 18, max: 80, default: 55 },
} as const

export function AgeInput({ state, audience, onSubmit }: StepInputProps) {
  const bounds = AGE_BOUNDS[audience]
  const [age, setAge] = useState(parseInt(state.age ?? '', 10) || bounds.default)
  const isMax = age >= bounds.max
  const display = isMax ? `${bounds.max}+ år` : `${age} år`
  const submit = () => onSubmit({ age: isMax ? `${bounds.max}+` : String(age) })
  return (
    <div className="input-dock">
      <div className="slider-display">
        <div className="slider-value">{display}</div>
      </div>
      <input
        type="range"
        className="slider-track"
        min={bounds.min}
        max={bounds.max}
        step={1}
        value={age}
        onChange={(e) => setAge(parseInt(e.target.value, 10))}
      />
      <div className="slider-bounds">
        <span>{bounds.min} år</span>
        <span>{bounds.max}+ år</span>
      </div>
      <button className="btn-send full" onClick={submit}>Videre</button>
    </div>
  )
}
